<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="invoicePolicyList"
      :pagination.sync="pagination"
      :hide-default-footer="true"
    >
      <template v-slot:item="props">
        <tr @click="edit(props.item)">
          <td style="width:30%;">
            <p>{{props.item.name}}</p>
          </td>
          <td style="width:30%;">
            <p>{{props.item.user.id + " " + props.item.user.name}}</p>
          </td>
          <td style="width:30%;">
            <p>{{props.item.short_name}}</p>
          </td>
          <td style="width:30%;">
            <p>{{props.item.enabled}}</p>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "repeat_service_list",
  components: {},
  props: {
    invoicePolicyList: Array,
    paginationProp: Object
  },
  mounted: async function() {},
  data: function() {
    return {
      message: "",
      pagination: this.paginationProp,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "User",
          align: "left",
          sortable: false,
          value: "user"
        },
        {
          text: "Short Name",
          align: "left",
          sortable: false,
          value: "user"
        },
        {
          text: "Enabled",
          align: "left",
          sortable: false,
          value: "user"
        }
      ]
    };
  },
  methods: {
    edit: function(invoicePolicy) {
      this.$emit("select", invoicePolicy);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
